import { Button } from '@mui/material';
import React from 'react';

interface PartActionsFooterProps {
  isPartTypeStep: boolean;
  isExceptionalStep: boolean;
  isConfirmStep: boolean;
  isInteractionStep: boolean;
  canSubmit: boolean;
  isBlocked: boolean;
  canSubmitExceptional: boolean;
  isCreating: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onCancel: () => void;
  onInteractionSubmit: () => Promise<void>;
  onExceptionalSubmit: () => void;
  onConfirmSubmit: () => Promise<void>;
}

export const PartActionsFooter: React.FC<PartActionsFooterProps> = ({
  isPartTypeStep,
  isExceptionalStep,
  isConfirmStep,
  isInteractionStep,
  canSubmit,
  isBlocked,
  canSubmitExceptional,
  isCreating,
  isSubmitting,
  onBack,
  onCancel,
  onInteractionSubmit,
  onExceptionalSubmit,
  onConfirmSubmit,
}) => {
  if (isPartTypeStep) {
    return (
      <Button onClick={onCancel} variant="outlined" fullWidth>
        Cancel
      </Button>
    );
  }

  const cancelHandler = isExceptionalStep ? onBack : onCancel;
  const cancelLabel = isExceptionalStep ? 'Back' : 'Cancel';
  const submitHandler = isInteractionStep
    ? onInteractionSubmit
    : isExceptionalStep
      ? onExceptionalSubmit
      : onConfirmSubmit;
  const getSubmitLabel = (): string => {
    if (isCreating) return 'Creating...';
    if (isSubmitting) return 'Submitting...';
    if (isInteractionStep) return 'Submit';
    return isExceptionalStep ? 'Create Part' : 'Confirm';
  };
  const isSubmitDisabled =
    (isConfirmStep && !canSubmit) ||
    (isInteractionStep && isBlocked) ||
    (isExceptionalStep && (!canSubmitExceptional || isCreating)) ||
    isSubmitting;

  return (
    <>
      <Button onClick={cancelHandler} variant="outlined" fullWidth>
        {cancelLabel}
      </Button>
      <Button onClick={submitHandler} variant="contained" fullWidth disabled={isSubmitDisabled}>
        {getSubmitLabel()}
      </Button>
    </>
  );
};
